import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import { bucketlink2 } from '../../config/fire-conf';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import { useSelector } from 'react-redux';
import { Upload } from 'antd';
import ImgCrop from 'antd-img-crop';
import AddOutlinedIcon from '@material-ui/icons/AddOutlined';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { getMaxNftSize, getMaxNftBgSize } from '../../services/common-query';

import { makeStyles } from '@material-ui/core/styles';
import {
  collection,
  getDocs,
  doc,
  query,
  where,
  writeBatch,
} from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import { uploadBytes, ref } from 'firebase/storage';
import { nftFirebaseStorage } from '../../config/firebaseStorage';
import moment from 'moment';

let maxNftSize = {
  val: 0,
  mb: 0,
};

let maxNftBgSize = {
  val: 0,
  mb: 0,
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ArtistCreationDialog(props) {
  const userDataRedux = useSelector((state) => state.authReducer.userData);

  const [artistDetails, setartistDetails] = useState({
    name: '',
    bio: '',
    facebook: '',
    instagram: '',
    spotify: '',
    apple: '',
    // medium: "",
    tiktok: '',
    twitter: '',
    followers: 0,
    following: 0,
  });
  const [backgroundImage, setbackgroundImage] = useState([]);
  const [profileImage, setprofileImage] = useState([]);
  const [loadingUpdateBtn, setloadingUpdateBtn] = useState(false);

  useEffect(() => {
    getMaxImgSize();
  }, []);

  const getMaxImgSize = async () => {
    maxNftSize = await getMaxNftSize();
    maxNftBgSize = await getMaxNftBgSize();
  };

  const handleClose = () => {
    props.setdialogState(false);
  };

  const createArtist = async (e) => {
    e.preventDefault();
    setloadingUpdateBtn(true);

    try {
      //unique artist name
      let isUnique = false;
      const q = query(
        collection(firebaseFireStore, 'musicartArtists'),
        where('lowerCaseName', '==', artistDetails.name.toLowerCase()),
      );

      let snap = await getDocs(q);

      if (snap.empty) {
        isUnique = true;
      }

      if (!isUnique) {
        setloadingUpdateBtn(false);

        toast.error(
          `MusicArtist with this name already exists, Please use a different one.`,
          {
            position: 'bottom-left',
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          },
        );
        return;
      }

      if (!backgroundImage || backgroundImage.length === 0) {
        //validating image uploadation
        toast.error(`Please upload MusicArtist background image!`, {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setloadingUpdateBtn(false);
        return null;
      }

      if (!profileImage || profileImage.length === 0) {
        //validating image uploadation
        toast.error(`Please upload MusicArtist profile image!`, {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setloadingUpdateBtn(false);
        return null;
      }

      let artistId = uuidv4();

      let uploadTask1 = ref(nftFirebaseStorage, 'artistBg/' + artistId);

      await uploadBytes(uploadTask1, backgroundImage[0].originFileObj);

      let imgBgUrl = `${bucketlink2}artistBg%2F${artistId}`;
      //uploading profile image
      let uploadTask2 = ref(nftFirebaseStorage, 'artistProfile/' + artistId);
      await uploadBytes(uploadTask2, profileImage[0].originFileObj);
      let imgProfileUrl = `${bucketlink2}artistProfile%2F${artistId}`;

      let batch = writeBatch(firebaseFireStore);

      let artistDetailsRef = doc(
        firebaseFireStore,
        'musicartArtists',
        artistId,
      );

      let artistDetailsObj = { ...artistDetails };

      artistDetailsObj.thumbnailImage = imgBgUrl;
      artistDetailsObj.photoUrl = imgProfileUrl;
      artistDetailsObj.nftsCount = 0;

      artistDetailsObj.creatorId = userDataRedux.uid;
      artistDetailsObj.id = artistId;
      artistDetailsObj.adminState = 'APPROVED';
      artistDetailsObj.lowerCaseName = artistDetailsObj.name.toLowerCase();
      artistDetailsObj.creationDate = Number(moment().format('x'));

      batch.set(artistDetailsRef, artistDetailsObj);

      await batch.commit();

      setloadingUpdateBtn(false);
      toast.success('MusicArtist created successfully', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });

      console.log(
        'URL.createObjectURL(profileImage[0].originFileObj)',
        URL.createObjectURL(profileImage[0].originFileObj),
      );

      props.setartistList([
        ...props.artistList,
        {
          ...artistDetailsObj,
          artistId: artistId,
          photoUrl: URL.createObjectURL(profileImage[0].originFileObj),
        },
      ]);
      props.setSelectedArtist({
        ...artistDetailsObj,
        artistId: artistId,
        photoUrl: URL.createObjectURL(profileImage[0].originFileObj),
      });
      props.setArtistId(artistId, artistDetails.name);

      setartistDetails({
        name: '',
        bio: '',
        facebook: '',
        instagram: '',
        tiktok: '',
        twitter: '',
        followers: 0,
      });
      setbackgroundImage([]);
      setprofileImage([]);

      handleClose();
    } catch (err) {
      console.log('catch err', err);
      toast.error(err.message, {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });

      setloadingUpdateBtn(false);
      return 'error';
    }
  };

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow.document.write(image.outerHTML);
  };

  const onChangeBgImage = ({ fileList: newFileList }) => {
    if (newFileList[0] && newFileList[0].size > maxNftBgSize.val) {
      toast.error(`Image must be smaller than ${maxNftBgSize.mb} MB`, {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
    } else {
      setbackgroundImage(newFileList);
    }
  };

  const onChangeProfileImage = ({ fileList: newFileList }) => {
    if (newFileList[0] && newFileList[0].size > maxNftSize.val) {
      toast.error(`Image must be smaller than ${maxNftSize.mb} MB`, {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
    } else {
      setprofileImage(newFileList);
    }
  };

  return (
    <Dialog
      open={props.dialogState}
      TransitionComponent={Transition}
      keepMounted
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      fullWidth
      style={{ zIndex: 1000 }}
      maxWidth="md"
      onClose={handleClose}
      className="ArtistDetails_Dialog"
    >
      <h5
        className="text-lg font-semibold"
        style={{ padding: '18px 24px 20px 24px' }}
      >
        Edit Artist Details
      </h5>
      <div className="dialog-close-medium">
        <button
          className="bg-white text-black my-2 text-lg font-light h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300"
          type="button"
          onClick={handleClose}
        >
          <i className="fa fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <DialogContent>
        <>
          <form
            className="sign__form sign__form--mint"
            id="artist-creation-form"
            style={{ marginTop: 10 }}
            onSubmit={createArtist}
          >
            <div className="row">
              {/* //details */}
              <div className="w-full px-4">
                <h4 className="sign__title">MusicArtist Details</h4>
              </div>
              <div className="w-full px-4">
                <div className="sign__group">
                  <label className="sign__label" htmlFor="artist-name">
                    MusicArtist Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="artist-name"
                    type="text"
                    className="sign__input"
                    placeholder="e.g. 'John Lee'"
                    required
                    value={artistDetails.name}
                    onChange={(e) => {
                      let modifiedObj = {
                        ...artistDetails,
                      };
                      modifiedObj.name = e.target.value.trimStart();
                      setartistDetails(modifiedObj);
                    }}
                    pattern=".*\S+.*"
                    title="This field is required"
                  />
                  {artistDetails &&
                    artistDetails.name &&
                    artistDetails.name.length > 0 && (
                      <button
                        type="button"
                        onClick={() => {
                          let modifiedObj = {
                            ...artistDetails,
                          };
                          modifiedObj.name = '';
                          setartistDetails(modifiedObj);
                        }}
                        className="close_icon"
                      >
                        <HighlightOffIcon />
                      </button>
                    )}
                </div>
              </div>

              <div className="w-full px-4">
                <div className="sign__group">
                  <label className="sign__label" htmlFor="artist-bio">
                    MusicArtist Bio <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    id="artist-bio"
                    className="sign__textarea"
                    placeholder="MusicArtist details"
                    value={artistDetails.bio}
                    onChange={(e) => {
                      let modifiedObj = {
                        ...artistDetails,
                      };
                      modifiedObj.bio = e.target.value.trimStart();
                      setartistDetails(modifiedObj);
                    }}
                    required
                  ></textarea>
                  {artistDetails &&
                    artistDetails.bio &&
                    artistDetails.bio.length > 0 && (
                      <button
                        type="button"
                        onClick={() => {
                          let modifiedObj = {
                            ...artistDetails,
                          };
                          modifiedObj.bio = '';
                          setartistDetails(modifiedObj);
                        }}
                        className="close_icon"
                        style={{
                          top: '55%',
                          marginTop: -10,
                          marginRight: -3,
                        }}
                      >
                        <HighlightOffIcon />
                      </button>
                    )}
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="sign__group">
                  <label className="sign__label">
                    MusicArtist Background Image{' '}
                    <span className="text-red-500">*</span>
                  </label>

                  <ImgCrop rotate aspect={2 / 1}>
                    <Upload
                      customRequest={dummyRequest}
                      listType="picture-card"
                      fileList={backgroundImage}
                      onChange={onChangeBgImage}
                      onPreview={onPreview}
                    >
                      {backgroundImage.length < 1 && <AddOutlinedIcon />}
                    </Upload>
                  </ImgCrop>
                </div>
              </div>

              <div className="w-full lg:w-4/12 px-4">
                <div className="sign__group">
                  <label className="sign__label">
                    MusicArtist Profile Image{' '}
                    <span className="text-red-500">*</span>
                  </label>

                  <ImgCrop rotate>
                    <Upload
                      customRequest={dummyRequest}
                      listType="picture-card"
                      fileList={profileImage}
                      onChange={onChangeProfileImage}
                      onPreview={onPreview}
                    >
                      {profileImage.length < 1 && <AddOutlinedIcon />}
                    </Upload>
                  </ImgCrop>
                </div>
              </div>

              <div className="w-full px-4 mt-4">
                <h4 className="sign__title">
                  Artist Profiles
                  <span className="sign__label" style={{ paddingLeft: 10 }}>
                    (optional)
                  </span>
                </h4>
              </div>
              <div className="w-full md:w-6/12 px-4">
                <div className="sign__group">
                  <label className="sign__label" htmlFor="artist-twitter">
                    Spotify
                  </label>
                  <input
                    id="artist-twitter"
                    type="text"
                    className="sign__input"
                    value={artistDetails.spotify}
                    onChange={(e) => {
                      let modifiedObj = {
                        ...artistDetails,
                      };
                      modifiedObj.spotify = e.target.value.trimStart();
                      setartistDetails(modifiedObj);
                    }}
                    placeholder="e.g. https://open.spotify.com/artist/..."
                  />
                  {artistDetails &&
                    artistDetails.spotify &&
                    artistDetails.spotify.length > 0 && (
                      <button
                        type="button"
                        onClick={() => {
                          let modifiedObj = {
                            ...artistDetails,
                          };
                          modifiedObj.spotify = '';
                          setartistDetails(modifiedObj);
                        }}
                        className="close_icon"
                      >
                        <HighlightOffIcon />
                      </button>
                    )}
                </div>
              </div>
              <div className="w-full md:w-6/12 px-4">
                <div className="sign__group">
                  <label className="sign__label" htmlFor="artist-twitter">
                    Apple
                  </label>
                  <input
                    id="artist-twitter"
                    type="text"
                    className="sign__input"
                    value={artistDetails.apple}
                    onChange={(e) => {
                      let modifiedObj = {
                        ...artistDetails,
                      };
                      modifiedObj.apple = e.target.value.trimStart();
                      setartistDetails(modifiedObj);
                    }}
                    placeholder="e.g. https://music.apple.com/gb/artist/..."
                  />
                  {artistDetails &&
                    artistDetails.apple &&
                    artistDetails.apple.length > 0 && (
                      <button
                        type="button"
                        onClick={() => {
                          let modifiedObj = {
                            ...artistDetails,
                          };
                          modifiedObj.apple = '';
                          setartistDetails(modifiedObj);
                        }}
                        className="close_icon"
                      >
                        <HighlightOffIcon />
                      </button>
                    )}
                </div>
              </div>
              <div className="w-full md:w-6/12 px-4">
                <div className="sign__group">
                  <label className="sign__label" htmlFor="artist-aurovine">
                    Aurovine
                  </label>
                  <input
                    id="artist-aurovine"
                    type="text"
                    className="sign__input"
                    value={artistDetails.aurovine}
                    onChange={(e) => {
                      let modifiedObj = {
                        ...artistDetails,
                      };
                      modifiedObj.aurovine = e.target.value.trimStart();
                      setartistDetails(modifiedObj);
                    }}
                    placeholder="e.g. https://www.aurovine.com/artistProfile/..."
                  />
                  {artistDetails &&
                    artistDetails.aurovine &&
                    artistDetails.aurovine.length > 0 && (
                      <button
                        type="button"
                        onClick={() => {
                          let modifiedObj = {
                            ...artistDetails,
                          };
                          modifiedObj.aurovine = '';
                          setartistDetails(modifiedObj);
                        }}
                        className="close_icon"
                      >
                        <HighlightOffIcon />
                      </button>
                    )}
                </div>
              </div>
              {/* //Urls links */}
              <div className="w-full px-4 mt-4">
                <h4 className="sign__title">
                  Social Profiles
                  <span className="sign__label" style={{ paddingLeft: 10 }}>
                    (optional)
                  </span>
                </h4>
              </div>

              <div className="w-full md:w-6/12 px-4">
                <div className="sign__group">
                  <label className="sign__label" htmlFor="artist-twitter">
                    Twitter Profile
                  </label>
                  <input
                    id="artist-twitter"
                    type="text"
                    className="sign__input"
                    value={artistDetails.twitter}
                    onChange={(e) => {
                      let modifiedObj = {
                        ...artistDetails,
                      };
                      modifiedObj.twitter = e.target.value.trimStart();
                      setartistDetails(modifiedObj);
                    }}
                    placeholder="e.g. https://twitter.com/username"
                  />
                  {artistDetails &&
                    artistDetails.twitter &&
                    artistDetails.twitter.length > 0 && (
                      <button
                        type="button"
                        onClick={() => {
                          let modifiedObj = {
                            ...artistDetails,
                          };
                          modifiedObj.twitter = '';
                          setartistDetails(modifiedObj);
                        }}
                        className="close_icon"
                      >
                        <HighlightOffIcon />
                      </button>
                    )}
                </div>
              </div>
              <div className="w-full md:w-6/12 px-4">
                <div className="sign__group">
                  <label
                    className="sign__label"
                    htmlFor="artist-tiktok-profile"
                  >
                    TikTok Profile
                  </label>
                  <input
                    id="artist-tiktok-profile"
                    type="text"
                    className="sign__input"
                    placeholder="e.g. https://www.tiktok.com/@username"
                    value={artistDetails.tiktok}
                    onChange={(e) => {
                      let modifiedObj = {
                        ...artistDetails,
                      };
                      modifiedObj.tiktok = e.target.value.trimStart();
                      setartistDetails(modifiedObj);
                    }}
                  />
                  {artistDetails &&
                    artistDetails.tiktok &&
                    artistDetails.tiktok.length > 0 && (
                      <button
                        type="button"
                        onClick={() => {
                          let modifiedObj = {
                            ...artistDetails,
                          };
                          modifiedObj.tiktok = '';
                          setartistDetails(modifiedObj);
                        }}
                        className="close_icon"
                      >
                        <HighlightOffIcon />
                      </button>
                    )}
                </div>
              </div>
              <div className="w-full md:w-6/12 px-4">
                <div className="sign__group">
                  <label className="sign__label" htmlFor="artist-Insta">
                    Instagram Profile
                  </label>
                  <input
                    id="artist-Insta"
                    type="text"
                    className="sign__input"
                    placeholder="e.g. https://www.instagram.com/username"
                    value={artistDetails.instagram}
                    onChange={(e) => {
                      let modifiedObj = {
                        ...artistDetails,
                      };
                      modifiedObj.instagram = e.target.value.trimStart();
                      setartistDetails(modifiedObj);
                    }}
                  />
                  {artistDetails &&
                    artistDetails.instagram &&
                    artistDetails.instagram.length > 0 && (
                      <button
                        type="button"
                        onClick={() => {
                          let modifiedObj = {
                            ...artistDetails,
                          };
                          modifiedObj.instagram = '';
                          setartistDetails(modifiedObj);
                        }}
                        className="close_icon"
                      >
                        <HighlightOffIcon />
                      </button>
                    )}
                </div>
              </div>
              <div className="w-full md:w-6/12 px-4">
                <div className="sign__group">
                  <label className="sign__label" htmlFor="artist-facebook">
                    Facebook Profile
                  </label>
                  <input
                    id="artist-facebook"
                    type="text"
                    className="sign__input"
                    placeholder="e.g. https://www.facebook.com/username"
                    value={artistDetails.facebook}
                    onChange={(e) => {
                      let modifiedObj = {
                        ...artistDetails,
                      };
                      modifiedObj.facebook = e.target.value.trimStart();
                      setartistDetails(modifiedObj);
                    }}
                  />
                  {artistDetails &&
                    artistDetails.facebook &&
                    artistDetails.facebook.length > 0 && (
                      <button
                        type="button"
                        onClick={() => {
                          let modifiedObj = {
                            ...artistDetails,
                          };
                          modifiedObj.facebook = '';
                          setartistDetails(modifiedObj);
                        }}
                        className="close_icon"
                      >
                        <HighlightOffIcon />
                      </button>
                    )}
                </div>
              </div>

              {/* //update btn */}
              <div className="w-full xl:w-3/12 px-4 mt-2">
                {loadingUpdateBtn ? (
                  <div
                    className="flex justify-center	w-full sign__btn"
                    style={{ backgroundColor: 'transparent' }}
                  >
                    <i className="fas fa-circle-notch animate-spin text-blueGray-800 mx-auto"></i>
                  </div>
                ) : (
                  <button type="submit" className="sign__btn">
                    Create
                  </button>
                )}
              </div>
            </div>
          </form>
        </>
      </DialogContent>
    </Dialog>
  );
}

const useStyles = makeStyles(() => ({
  selectEle: {
    minWidth: 150,
  },
}));
